
const variants = [1, 2];

export default {
  name: 'EditoHighlight',
  props: {
    /**
     * Ctas data
     * @see patterns/ui-cta
     */
    cta: {
      type: Object,
      default: undefined,
    },
    /**
     * Header icon name
     */
    icon: {
      type: String,
      default: undefined,
    },
    /**
     * Main text
     */
    text: {
      type: String,
      default: undefined,
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: undefined,
    },
    /**
     * theme variant
     */
    variant: {
      type: Number,
      default: variants[0],
      validator: (variant) => variants.includes(variant),
    },
  },
  computed: {
    cssClass() {
      return [`-variant-${this.variant}`];
    },
    ctaAttributes() {
      if (!this.cta) {
        return undefined;
      }

      const cta = {
        size: 'l',
        variant: 3,
        ...this.cta,
      };

      return cta;
    },
  },
};
